import { render, staticRenderFns } from "./user-selector.vue?vue&type=template&id=21d440d7&scoped=true"
import script from "./user-selector.vue?vue&type=script&lang=js"
export * from "./user-selector.vue?vue&type=script&lang=js"
import style0 from "./user-selector.vue?vue&type=style&index=0&id=21d440d7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d440d7",
  null
  
)

export default component.exports